<ds-panel [showHeader]="false" class="p-mb-3">
  <ds-table
    [sterownik]="sterownik"
    [model]="tableData"
    [emptyMessage]="'brakSubskrypcji' | transloco"
    [rozwijak]="rozwijakTemplate"
    [loading]="dataFilterService.loading$ | async"
    [columnTemplates]="{systemId: numerKrs, subskrypcjaOd: subskrypcjaOd, subskrypcjaDo: subskrypcjaDo, noweZdarzenia: noweZdarzenia, statusKod: statusKod, powiadomienieEmail: powiadomienieEmail, actions: actionsTmpl}"></ds-table>
</ds-panel>

<ng-template #numerKrs let-row>
  <div class="ds-column-title">{{'numerKrs' | transloco}}</div>
  <div class="ds-column-value">
    <a class="link" (click)="getLink($event, row.systemId)" target="_blank" href="#" title="Przejdź do szczegółów podmiotu o numerze KRS">
      {{row.systemId}}</a>
  </div>
</ng-template>

<ng-template #subskrypcjaOd let-row>
  <div class="ds-column-title">{{'subskrypcjaOd' | transloco}}</div>
  <div class="ds-column-value">{{row.subskrypcjaOd | date: formatDate}}</div>
</ng-template>

<ng-template #subskrypcjaDo let-row>
  <div class="ds-column-title">{{'subskrypcjaDo' | transloco}}</div>
  <div class="ds-column-value">{{row.subskrypcjaDo | date: formatDate}}</div>
</ng-template>

<ng-template #noweZdarzenia let-row>
  <div class="ds-column-title">{{'noweZdarzenia' | transloco}}</div>
  <div class="ds-column-value"><ds-status [severity]="row.noweZdarzenia.length > 0 ? 'success' : 'error'">{{row.noweZdarzenia.length > 0 ? 'TAK' : 'NIE' }}</ds-status></div>
</ng-template>

<ng-template #statusKod let-row>
  <div class="ds-column-title">{{'statusSubskrypcji' | transloco}}</div>
  <div class="ds-column-value"><ds-status [severity]="getStatusSeverity(row.status)">{{row.status }}</ds-status></div>
</ng-template>

<ng-template #powiadomienieEmail let-row>
  <div class="ds-column-title">{{'subskrypcjaOd' | transloco}}</div>
  <div class="ds-column-value"><ds-status [severity]="row.powiadomienieEmail ? 'success' : 'error'">{{row.powiadomienieEmail ? 'TAK' : 'NIE'}}</ds-status></div>
</ng-template>

<ng-template #actionsTmpl let-element>
  <div class="ds-column-title">{{'dzialania' | transloco}}</div>
  <div class="ds-column-value">
    <div class="row-button-actions">
      <ds-button
        *ngIf="element.status == statusSubskrypcji.AKTYWNA || element.status == statusSubskrypcji.WYGASAJACA || element.status == statusSubskrypcji.ZAMOWIONA"
        severity="link"
        icon="pi pi-pencil"
        tooltipPosition="top"
        [pTooltip]="'edytuj' | transloco"
        (click)="modify(element, 'edycja')"
        label="Edytuj subskrypcję"
        [styleClass]="'p-button-label-display-none'"
      ></ds-button>
      <ds-button
        *ngIf="element.status == statusSubskrypcji.AKTYWNA || element.status == statusSubskrypcji.WYGASAJACA"
        severity="link"
        icon="pi pi-ban"
        tooltipPosition="top"
        [pTooltip]="'odwolaj' | transloco"
        (click)="openDialog(element, 'odwolanie')"
        label="Odwołaj subskrypcję"
        [styleClass]="'p-button-label-display-none'"
      ></ds-button>
      <ds-button
        *ngIf="element.status == statusSubskrypcji.WYGASLA || element.status == statusSubskrypcji.ODWOLANA"
        severity="link"
        icon="pi pi-replay"
        tooltipPosition="top"
        [pTooltip]="'przywroc'|transloco"
        (click)="modify(element, 'przywrocenie')"
        label="Przywróć subskrypcję"
        [styleClass]="'p-button-label-display-none'"
      ></ds-button>
      <ds-button
        *ngIf="element.status == statusSubskrypcji.WYGASLA || element.status == statusSubskrypcji.ODWOLANA || element.status == statusSubskrypcji.ZAMOWIONA"
        severity="link"
        icon="pi pi-times"
        tooltipPosition="top"
        [pTooltip]="'usun'|transloco"
        (click)="openDialog(element, 'usuniecie')"
        label="Usuń subskrypcję"
        [styleClass]="'p-button-label-display-none'"
      ></ds-button>
    </div>
  </div>
</ng-template>

<ng-template #rozwijakTemplate let-context >
    <td class="noweZdarzenia" [attr.colspan]="context.colSpan">
        <ds-panel class="p-col-12">
          <ds-panel-header>{{ 'noweZdarzenia' | transloco }}</ds-panel-header>
          <ds-table
            [sterownik]="sterownikSzczegoly"
            [model]="context.rowData.noweZdarzenia"
            [columnTemplates]="{dataZdarzenia: dataZdarzenia}"
            [emptyMessage]="'brakZdarzen' | transloco"></ds-table>
          <div class="p-d-flex p-jc-center p-mt-2">
            <ds-button class="p-mt-3" severity="border" (click)="showDetails(context.rowData.id)" [label]="'zobaczWszystkie' | transloco"></ds-button>
          </div>
        </ds-panel>
    </td>
</ng-template>

<ng-template #dataZdarzenia let-row>
  <div class="ds-column-title">{{'dataZdarzenia' | transloco}}</div>
  <div class="ds-column-value">{{row.dataZdarzenia | date: formatDate}}</div>
</ng-template>

<ds-confirm-dialog width="450px" [header]="'usuniecieNaglowek' | transloco" [message]="'usuniecieWiadomosc' | transloco" (closed)="confirmClosed($event)" [(openDialog)]="dialogOpened"></ds-confirm-dialog>

<ds-modal #odwolanieModal width="450px">
  <div dsModalTitle>{{ 'odwolanieNaglowek' | transloco }}</div>
  <div dsModalContent>
    <p>{{ 'odwolanieWiadomosc' | transloco }}</p>
    <div class="p-mt-4 p-d-flex p-flex-row p-jc-end">
      <div class="p-mr-2">
        <ds-button severity="border" [label]="'anuluj' | transloco" (onClick)="hideModal()"></ds-button>
      </div>
      <div class="p-mr-2">
        <ds-button severity="primary" [label]="'odwoluje' | transloco" (onClick)="cancelSubscription(subskrybcjaId)"></ds-button>
      </div>
      <div class="p-mr-3">
        <ds-button severity="primary" [label]="'odwolujeIUsuwam' | transloco" [pTooltip]="'wybranaSubskrypcjaZostanieUsunieta' | transloco" (onClick)="deleteSubscription(subskrybcjaId)"></ds-button>
      </div>
    </div>
  </div>
</ds-modal>

<ds-modal #monitorowanieModal>
  <div dsModalTitle>{{ 'monitorowaniePodmiotu' | transloco }}</div>
  <div dsModalContent>
    <app-monitorowanie-podmiotu-form [monitorowanieForm]="monitorowaniePodmiotuForm" [status]="selectedStatus"></app-monitorowanie-podmiotu-form>
    <div class="p-mt-4 p-d-flex p-flex-row p-jc-end">
      <div class="p-mr-2">
        <ds-button severity="border" [label]="'anuluj' | transloco" (onClick)="hideModal()"></ds-button>
      </div>
      <div class="p-mr-3">
        <ds-button severity="primary" [disabled]="monitorowaniePodmiotuForm?.invalid || saveDisabled" [label]="'zapiszZmiany' | transloco" (onClick)="save(monitorowaniePodmiotuForm)"></ds-button>
      </div>
    </div>
  </div>
</ds-modal>

<ds-modal #wyszukiwarkaModal [formGroup]="wyszukiwarkaForm">
  <div dsModalTitle>{{ 'wybierzRodzajRejestru' | transloco }}</div>
  <div dsModalContent>
    <div class="p-grid">
      <div class="p-col-12">
        <ds-radio
          formControlName="rodzajRejestru"
          value="P"
          [label]="'rejestrPrzedsiebiorcow' | transloco"
        ></ds-radio>
      </div>
    </div>
    <div class="p-grid">
      <div class="p-col-12">
        <ds-radio
          formControlName="rodzajRejestru"
          value="S"
          [label]="'rejestrStowarzyszen' | transloco"
        ></ds-radio>
      </div>
    </div>
    <div class="p-mt-4 p-d-flex p-flex-row p-jc-end">
      <div class="p-mr-2">
        <ds-button severity="border" [label]="'anuluj' | transloco" (onClick)="hideModal()"></ds-button>
      </div>
      <div class="p-mr-3">
        <ds-button severity="primary" [disabled]="wyszukiwarkaForm?.invalid" [label]="'przejdzDoWyszukiwarki' | transloco"
          (onClick)="saveWyszukiwarka()">
        </ds-button>
      </div>
    </div>
  </div>
</ds-modal>
